module.exports = __webpack_public_path__ + "img/068-moonset.471ba088.svg";